<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { Capacitor } from '@capacitor/core';
import BaseDialog from '@/components/BaseDialog.vue';
import MidiDeviceSelector from '@/components/MidiDeviceSelector.vue';
import MidiDeviceIOSInfo from '@/components/MidiDeviceIOSInfo.vue';
import { useToast } from '@/composables/useToast';
import { useMidiAudioSetup } from '@/composables/useMidiAudioSetup';

const showiOSWebInfo = ref(false);
const isCompleting = ref(false);
const { createToast } = useToast();
const { completeMidiSetup } = useMidiAudioSetup();

defineProps<{
  isVisible: boolean
}>();

onMounted(() => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);

  if (isIOS && Capacitor.getPlatform() === 'web') {
    showiOSWebInfo.value = true;
  }
});

const handleConfirm = async () => {
  if (isCompleting.value) return;
  isCompleting.value = true;
  await completeMidiSetup(() => {
    createToast({
      type: 'error',
      message: 'Unable to initialize audio. Please tap Continue again.',
    });
  });
  isCompleting.value = false;
};
</script>

<template>
  <BaseDialog :is-visible="isVisible" :close-on-request="false" @close="handleConfirm">
    <div class="space-y-4">
      <MidiDeviceIOSInfo v-if="showiOSWebInfo" v-model:show="showiOSWebInfo" />
      <MidiDeviceSelector v-else />
      <button
        v-if="!showiOSWebInfo"
        class="w-full bg-primary text-text-primary rounded-xl py-3 px-4 font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        :disabled="isCompleting"
        @click="handleConfirm"
      >
        {{ isCompleting ? 'Preparing...' : 'Continue' }}
      </button>
    </div>
  </BaseDialog>
</template>
